import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="disc">
        <em>
          This is a free remix of{' '}
          <a
            href="https://cardsagainsthumanity.com/"
            rel="noopener noreferrer"
            target="_blank"
          >
            Cards&nbsp;Against&nbsp;Humanity
          </a>
          , which is licensed under{' '}
          <a
            href="https://creativecommons.org/licenses/by-nc-sa/2.0/"
            rel="noopener noreferrer"
            target="_blank"
          >
            Creative Commons BY-NC-SA 2.0 license
          </a>
          .
        </em>
      </div>
    </footer>
  );
};

export default Footer;